import { Card, Col, Row, Typography, Input, Button, message, Spin } from "antd";
import React, { useState } from "react";
import Post from "../services/Post";
import io from "socket.io-client";
import { useNavigate } from "react-router-dom";

const AddMoney = () => {
  const [amount, setAmount] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [processing, setProcessing] = useState(false); // Track payment progress

  const user = localStorage.getItem("user");
  const navigate = useNavigate();

  const handleAmountClick = (value) => {
    setAmount(value);
  };

  const applyCoupon = () => {
    if (coupon.trim()) {
      setAppliedCoupon(coupon);
    }
  };

  const pay_now = async () => {
    try {
      if (!amount) {
        message.error("Amount not found!");
        return null;
      }
  
      setProcessing(true);
  
      const res = await Post.PaymentLink(amount);
      console.log(res);
  
      const { paymentLink, order_id } = res.data;
  
      if (!paymentLink || !order_id) {
        message.error("Failed to retrieve payment link!");
        setProcessing(false);
        return null;
      }
  
      const paymentWindow = window.open(
        paymentLink,
        "_blank",
        "width=1000,height=800"
      );
  
      if (!paymentWindow) {
        message.error("Popup blocked! Please allow popups and try again.");
        setProcessing(false);
        return null;
      }
  
      let popupClosed = false;
  
      return new Promise((resolve, reject) => {
        const checkPopupClosed = setInterval(() => {
          if (paymentWindow.closed) {
            clearInterval(checkPopupClosed);
            popupClosed = true;
            message.error("Payment popup closed before completion!");
            setProcessing(false);
            reject(null);
          }
        }, 1000);
  
        const socket = io.connect("https://socket.rebatedekho.com");

        // Join a unique room for this payment
        console.log(order_id);
        socket.emit("join-room", order_id);
        console.log('room joined');

        socket.on("callback-event", (data) => {
          console.log("Payment callback received:", data);
          const parsedData = data;
  
          if (popupClosed) return;
  
          if (parsedData.STATUS_CODE === "RP000") {
            message.success(parsedData.ERROR_DESC);
            clearInterval(checkPopupClosed);
            socket.disconnect();
            resolve(parsedData.ORDER_ID);
          } else {
            message.error(parsedData.ERROR_DESC);
          }
        });
      });
    } catch (error) {
      message.error("Something went wrong while processing payment!");
      console.error(error);
      setProcessing(false);
      return null;
    }
  };

  const addmoney = async () => {
    setProcessing(true); // Show loading spinner

    try {
      const payId = await pay_now();
      console.log('payId', payId);

      if (payId) {
        const send = {
          amount: amount,
          type: "credit",
          transaction: "add_money",
          status: "success",
          pay_id: payId,
          method: "Online Payment",
          remark: `Rs ${amount} has been added successfully in your account`,
          description: `Rs ${amount} has been added successfully in your account`,
        };

        console.log("Data to send", send);

        const res = await Post.AddMoney(send);
        console.log("Response == ", res);

        if (res) {
          if (res.error) {
            console.log(res.error);
            message.error("Something went wrong");
            navigate(`/user/home`);
          } else {
            console.log("Success!");
            message.success("Successfully added Money!!");
            navigate(`/user/reciept/${res.data.id}`);
          }
        }
      }
    } catch (error) {
      console.error("Error in payment:", error);
      message.error("Error occurred");
    } finally {
      setProcessing(false); // Hide loading spinner
    }
  };

  return (
    <div className="layout-content">
      <Row gutter={[24, 24]} justify="center">
        <Col>
          <Card
            title={`Add Money to RebateDekho Wallet`}
            bordered={true}
            style={{ maxWidth: 500, padding: 20 }}
          >
            {/* Enter Amount Section */}
            <Row style={{ marginBottom: 16 }}>
              <Col span={24}>
                <Typography.Text strong>Enter Amount:</Typography.Text>
                <Input
                  type="number"
                  placeholder="Enter amount"
                  value={amount}
                  onChange={(e) => setAmount(Number(e.target.value))}
                  style={{ marginTop: 8 }}
                  disabled={processing} // Disable input during processing
                />
              </Col>
            </Row>

            {/* Quick Amount Buttons */}
            <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
              {[100, 300, 500, 1000].map((value) => (
                <Col key={value}>
                  <Button
                    type="primary"
                    ghost
                    onClick={() => handleAmountClick(value)}
                    style={{ color: "#a6cc43", borderColor: "#a6cc43" }}
                    disabled={processing} // Disable buttons during processing
                  >
                    ₹{value}
                  </Button>
                </Col>
              ))}
            </Row>

            {/* Payment Summary Section */}
            <Row style={{ marginBottom: 16 }}>
              <Col span={24}>
                <Typography.Text strong>Payment Summary:</Typography.Text>
                <div style={{ marginTop: 8 }}>
                  <Typography.Text>Total Amount: ₹{amount}</Typography.Text>
                </div>
              </Col>
            </Row>

            {/* Pay Now Button & Loading Indicator */}
            <Row>
              <Col span={24}>
                <Button
                  type="primary"
                  block
                  className="form-btn"
                  onClick={addmoney}
                  disabled={processing} // Disable button while processing
                >
                  {processing ? <Spin size="small" /> : "Pay Now"}
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddMoney;
